import Kunvil1 from "./kunvil (1).webp";
import Kunvil2 from "./kunvil (2).webp";
import Kunvil3 from "./kunvil (3).webp";
import Kunvil4 from "./kunvil (4).webp";
import Kunvil5 from "./kunvil (5).webp";
import Kunvil6 from "./kunvil (6).webp";
import Kunvil7 from "./kunvil (7).webp";
import Kunvil8 from "./kunvil (8).webp";
import Kunvil9 from "./kunvil (9).webp";

const kunvil = [
  Kunvil1,
  Kunvil2,
  Kunvil3,
  Kunvil4,
  Kunvil5,
  Kunvil6,
  Kunvil7,
  Kunvil8,
  Kunvil9,
];

export default kunvil;
